import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Category } from '../../core/models';
import { MainMarketSectionHeaderComponent } from './main-market-section-header/main-market-section-header.component';
import { CategoryMarketSectionHeaderComponent } from './category-market-section-header/category-market-section-header.component';

@Component({
    selector: 'app-base-market-section-header',
    standalone: true,
    imports: [MainMarketSectionHeaderComponent, CategoryMarketSectionHeaderComponent],
    templateUrl: './base-market-section-header.component.html',
    styleUrls: ['./base-market-section-header.component.css'],
})
export class BaseMarketSectionHeaderComponent implements OnInit {

  @Input() isCategorySelected: boolean = false;
  @Input() category$: Observable<Category>;

  constructor(
    ) { }

  ngOnInit(): void {
  }

}
